import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Detail} from 'pages/withAuth/adminPage/procedures/changeOffice/detail'
import {Update} from 'pages/withAuth/adminPage/procedures/changeOffice/update'

// @ts-ignore
import ChooseEmployee from 'procedures/ChooseEmployee'
// @ts-ignore
import {Flow} from 'procedures/changeOffice/Flow'

export const ChangeOfficeRoutes: RouteParams[] = [
  {
    key: 'change_office',
    path: WITH_AUTH_ADMIN_PATHS.CHANGE_OFFICE.INDEX,
    component: ChooseEmployee,
    exact: true,
    whiteList: ['full_admin', 'limited_admin'],
  },
  {
    key: 'change_office/detail',
    path: WITH_AUTH_ADMIN_PATHS.CHANGE_OFFICE.DETAIL,
    component: Detail,
    whiteList: ['full_admin', 'limited_admin'],
  },
  {
    key: 'change_office/flow',
    path: WITH_AUTH_ADMIN_PATHS.CHANGE_OFFICE.FLOW,
    component: Flow,
    whiteList: ['full_admin', 'limited_admin'],
  },
  {
    key: 'change_office/update',
    path: WITH_AUTH_ADMIN_PATHS.CHANGE_OFFICE.UPDATE,
    component: Update,
    whiteList: ['full_admin', 'limited_admin'],
  },
]
